export default [{
    path: '/news/detail',
    name: 'news-detail',
    meta: {
        title: '新闻',
        track: {
            evt: 'BRAND_NEWS_DETAIL',
            label: ''
        }
    },
    component: resolve => require.ensure([], () => resolve(require('../pages/news/detail.vue')), 'news-detail'),
}]



// WEBPACK FOOTER //
// ./src/routes/news.js